module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAACXBIWXMAAAsSAAALEgHS3X78AAAAYElEQVQoU2PUFyplwALKgWIdQOwKxHvQ5Zmw6SAkNsg1sQDdD/I0OnCBCoQCaWM0yfeMwND7T8jjaPJ7QDaBghUdgGxIA+IKID6LbhNIE0Y8IDkJpGG4xNN7qF9ANAYAAA3wD74L4XYQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/ButtonSquare/assets/img/cross_button_icon_dark.png
// module id = 556
// module chunks = 168707334958949